export default "__VITE_ASSET__03e706c1__"